import images from "./images";

const data = {
  user: {
    name: "Zahra Mirzaei",
    img: images.avt,
  }
};

export default data;
